import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function setRelatedModelsCarousel () {
  const productsCarousel = document.querySelectorAll('[data-related-models-swiper]');

  productsCarousel.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    if (carousel) {
      const swiper = new Swiper(carousel, {
        modules: [Navigation],
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 5,
        watchOverflow: true,
        speed: 1000,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          768: {
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      });
    }
  });
}